import React, { useState } from 'react';
import { AccountCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import '../../style/comment.css'
import CommentForm from './CommentForm';
import { useNavigate } from 'react-router-dom';

export default function Comment({comment, replies, currentUserId, deleteComment, activeComment, setActiveComment, addComment, parentCommentId=null, updateCommentContent}){

    const [showReplies, setShowReplies] = useState(false)
    const navigate = useNavigate();
    const canEditDelete = currentUserId === comment.author.id;
    const isReplying = activeComment && activeComment.type == "replying" && activeComment.id == comment._id
    const isEditing = activeComment && activeComment.type == "editing" && activeComment.id == comment._id
    const replyParentId = parentCommentId ? parentCommentId : comment._id
    
    const formattedDate = (dateTime) =>{
        const commentDateTime = new Date(dateTime)
        return commentDateTime.toLocaleDateString();   
    }

    const handleCancel = () =>{
        setActiveComment(null)
    }

    const redirectToUser=(userId)=>{
        navigate(`/account/${userId}`)
    }

    return(
        <div className='comment-container'>
            <div className='comment-user-image'>
                <IconButton onClick={()=>redirectToUser(comment.author.id)}>
                    <AccountCircle sx={{ fontSize: 39 }}/>
                </IconButton>
                </div>
            <div className='comment-body'>
                <div className='comment-body-header'>
                    <div className='comment-user-name'>{comment.author.firstName} {comment.author.lastName}</div>
                    <div className='comment-time'>{formattedDate(comment.dateTime)}</div>
                </div>

                {isEditing ?
                    <CommentForm
                    placeholderLabel="Edit" 
                    submitLabel="Edit" 
                    initialText={comment.text}
                    hasCancel={true}
                    handleCancel={handleCancel}
                    handleSubmit={(text)=>updateCommentContent(comment._id, text)}
                    />
                    :
                   <div className='comment-content'>{comment.text}</div>
                   }


                <div className='comment-actions'>
                    {!isReplying &&
                        <div
                        className='comment-action-button'
                        onClick={()=>setActiveComment({type:"replying", id:comment._id})}>Reply</div>
                    }

                    {canEditDelete && !isEditing &&
                    <div
                     className='comment-action-button' 
                     onClick={()=>setActiveComment({type:"editing", id:comment._id})}>Edit</div>}
                    {canEditDelete && 
                    <div
                     className='comment-action-button' 
                     onClick={()=>deleteComment(comment._id)}>Delete</div>}
                </div>

                {replies.length != 0 &&
                (showReplies ? 
                <div className='replies-header' onClick={()=>setShowReplies(false)}>Hide replies</div>
                :
                <div className='replies-header' onClick={()=>setShowReplies(true)}>View {replies.length} more replies</div>)
                }

                {isReplying && 
                <CommentForm
                 placeholderLabel="Reply" 
                 submitLabel="Reply" 
                 hasCancel={true}
                 handleCancel={handleCancel}
                 handleSubmit={(text)=>addComment(text, replyParentId)}
                 />
                }

                {showReplies && replies.length != 0 &&
                    (<div className='comment-replies'>
                    {   replies.map((reply)=>(
                    <Comment
                        key={reply._id} 
                        comment={reply} 
                        replies={[]} 
                        currentUserId={currentUserId} 
                        deleteComment={deleteComment}
                        activeComment={activeComment}
                        setActiveComment={setActiveComment}
                        addComment={addComment}
                        parentCommentId={comment._id}
                        updateCommentContent={updateCommentContent}
                        /> 
                        ))}
                    </div>)
                }

            </div>
        </div>
    )
}